// Copyright (c) 2016 Deere & Company

import KeyValuePair, {getDefaultState as getKeyValueDefaultState} from './key-value-pair';
import t from 'tcomb';

const ClaimReferenceInfo = t.struct({
    ownershipStatus: KeyValuePair,
    referenceNumber1: t.String,
    referenceNumber2: t.String,
    repairNumber: t.String
}, {
    name: 'ClaimReferenceInfo',
    strict: true
});

export const getDefaultState = () => new ClaimReferenceInfo({
    ownershipStatus: getKeyValueDefaultState(),
    referenceNumber1: '',
    referenceNumber2: '',
    repairNumber: ''
});

export default ClaimReferenceInfo;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/claim-reference-info.js